/**
 * ODDFISH — Our Team page (AOS, strike reveals, member popups)
 */
(function () {
  "use strict";

  var aosFlips = ["flip-left", "flip-right", "flip-up", "flip-down"];

  function initTeamPage() {
    var page = document.querySelector(".oddfish-team-page");
    if (!page) return;

    if (typeof AOS !== "undefined") {
      AOS.init({ once: true, duration: 800, easing: "ease-out-cubic", offset: 120 });
    }

    initScrollAnimations(page);
    initPopups(page);
  }

  function initScrollAnimations(page) {
    var ticking = false;

    function handleScroll() {
      var windowBottom = window.scrollY + window.innerHeight;

      page.querySelectorAll(".animate").forEach(function (section) {
        var rect = section.getBoundingClientRect();
        var sectionTop = window.scrollY + rect.top;
        var sectionBottom = sectionTop + rect.height - 50;

        if (windowBottom > sectionBottom) {
          section.classList.add("scrolled");
          section.querySelectorAll(".strike:not(.strike_btn)").forEach(function (el) {
            el.classList.add("strike-visible");
          });
          section.querySelectorAll("[data-aos]").forEach(function (el) {
            el.classList.add("aos-animate");
          });
        }
      });
    }

    window.addEventListener(
      "scroll",
      function () {
        if (!ticking) {
          requestAnimationFrame(function () {
            handleScroll();
            ticking = false;
          });
          ticking = true;
        }
      },
      { passive: true }
    );

    handleScroll();

    page.querySelectorAll(".strike_btn.strike").forEach(function (btn) {
      btn.classList.remove("strike-visible");
    });
  }

  function initPopups(page) {
    var popups = page.querySelectorAll(".team_member_popup");

    function closePopups() {
      popups.forEach(function (popup) {
        popup.classList.remove("active_hidden_section");
      });
      page.classList.remove("is-popup-open");
    }

    page.querySelectorAll(".team_member").forEach(function (member) {
      member.addEventListener("click", function (e) {
        e.stopPropagation();
        var popupId = member.getAttribute("data-popup");
        if (!popupId) return;

        closePopups();
        var popup = page.querySelector('[data-popup-id="' + popupId + '"]');
        if (popup) {
          popup.classList.add("active_hidden_section");
          page.classList.add("is-popup-open");
        }
      });
    });

    popups.forEach(function (popup) {
      popup.addEventListener("click", function () {
        closePopups();
      });

      var box = popup.querySelector(".team_member_box");
      if (box) {
        box.addEventListener("click", function (e) {
          e.stopPropagation();
        });
      }

      var closeBtn = popup.querySelector(".close");
      if (closeBtn) {
        closeBtn.addEventListener("click", function (e) {
          e.stopPropagation();
          closePopups();
        });
      }
    });

    document.addEventListener("click", function (e) {
      if (!e.target.closest(".team_member") && !e.target.closest(".team_member_popup")) {
        closePopups();
      }
    });

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") closePopups();
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initTeamPage);
  } else {
    initTeamPage();
  }
})();
